<template>
  <div class="p-10 px-6 pt-10 lg:p-20 border-t-2">
    <div class="lg:flex lg:justify-between lg:items-start">

      <div class="lg:order-1 lg:w-1/3 flex lg:justify-center text-xs mt-10 lg:mt-0">
        <div class="flex flex-col gap-3">
          <a class="flex items-center gap-2" :href="`https://wa.me/${$t('footer.contact.whatsapp')}`" target="_blank"
            aria-label="WhatsApp">
            <Icon name="mdi:whatsapp"></Icon>{{ $t('footer.contact.whatsapp') }}
          </a>
          <a class="flex items-center gap-2" :href="`mailto:associazionetau@virgilio.it`" target="_blank"
            aria-label="Email">
            <Icon name="mdi:email-outline"></Icon>associazionetau@virgilio.it
          </a>
          <div class="flex flex-col gap-2 pt-3">
            <p>{{ $t('footer.contact.follow-us') }}</p>
            <div class="flex gap-4">
              <a class="flex items-center gap-2" :href="`https://www.instagram.com/${$t('footer.contact.instagram')}`"
                target="_blank" aria-label="Instagram">
                <Icon name="mdi:instagram"></Icon>
              </a>
              <a class="flex items-center gap-2" :href="`https://www.facebook.com/associazionetau/`" target="_blank"
                aria-label="Facebook">
                <Icon name="mdi:facebook"></Icon>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="flex gap-4 lg:order-2 lg:w-1/3 mt-10 lg:mt-0 lg:justify-end">
        <div class="flex flex-col gap-4 uppercase lg:items-end">
          <NuxtLink :to="localePath('/privacy-policy')" target="_blank" class="size-fit min-h-6">
            <p class="text-xs">{{ $t('footer.privacy-policy') }}</p>
          </NuxtLink>
          <NuxtLink target="_blank" :to="localePath('/cookie-policy')" class="size-fit min-h-6">
            <p class="text-xs">{{ $t('footer.cookie-policy') }}</p>
          </NuxtLink>
          <NuxtLink :to="localePath('/trasparenza')" class="size-fit min-h-6">
            <p class="text-xs">{{ $t('footer.transparency') }}</p>
          </NuxtLink>
        </div>
      </div>

      <div class="lg:order-0 lg:w-1/3 flex flex-col lg:items-start">
        <nuxt-img sizes="xl:100vw lg:100vw md:100vw sm:100vw xs:100vw" class="cursor-pointer mt-10 lg:mt-0 h-24 w-24"
          src="/images/logo_nero.png" />
        <p class="py-2 text-[8px]">&copy; {{ new Date().getFullYear() }}</p>
        <div class="flex flex-col lg:mt-5">
          <p class="text-[8px]">{{ $t('footer.legal-address') }}</p>
          <p class="text-[8px]">{{ $t('footer.fiscal-code') }} 92236610926</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const config = useRuntimeConfig();
const baseImageUrl = config.public.BASE_IMAGE_URL;
</script>

<style></style>
